export const WITHOUT_DEPARTURE_REQUEST_GET_REQUEST =
  "WITHOUT_DEPARTURE_REQUEST_GET_REQUEST";
export const WITHOUT_DEPARTURE_REQUEST_GET_SUCCESS =
  "WITHOUT_DEPARTURE_REQUEST_GET_SUCCESS";
export const WITHOUT_DEPARTURE_REQUEST_GET_ERROR =
  "WITHOUT_DEPARTURE_REQUEST_GET_ERROR";
export const WITHOUT_DEPARTURE_REQUEST_GET_BY_KEY_REQUEST =
  "WITHOUT_DEPARTURE_REQUEST_GET_BY_KEY_REQUEST";
export const WITHOUT_DEPARTURE_REQUEST_GET_BY_KEY_SUCCESS =
  "WITHOUT_DEPARTURE_REQUEST_GET_BY_KEY_SUCCESS";
export const WITHOUT_DEPARTURE_REQUEST_GET_BY_KEY_ERROR =
  "WITHOUT_DEPARTURE_REQUEST_GET_BY_KEY_ERROR";
export const WITHOUT_DEPARTURE_REQUEST_ADD_REQUEST =
  "WITHOUT_DEPARTURE_REQUEST_ADD_REQUEST";
export const WITHOUT_DEPARTURE_REQUEST_ADD_SUCCESS =
  "WITHOUT_DEPARTURE_REQUEST_ADD_SUCCESS";
export const WITHOUT_DEPARTURE_REQUEST_ADD_ERROR =
  "WITHOUT_DEPARTURE_REQUEST_ADD_ERROR";
export const WITHOUT_DEPARTURE_REQUEST_EDIT_REQUEST =
  "WITHOUT_DEPARTURE_REQUEST_EDIT_REQUEST";
export const WITHOUT_DEPARTURE_REQUEST_EDIT_SUCCESS =
  "WITHOUT_DEPARTURE_REQUEST_EDIT_SUCCESS";
export const WITHOUT_DEPARTURE_REQUEST_EDIT_ERROR =
  "WITHOUT_DEPARTURE_REQUEST_EDIT_ERROR";
export const WITHOUT_DEPARTURE_REQUEST_DELETE_REQUEST =
  "WITHOUT_DEPARTURE_REQUEST_DELETE_REQUEST";
export const WITHOUT_DEPARTURE_REQUEST_DELETE_SUCCESS =
  "WITHOUT_DEPARTURE_REQUEST_DELETE_SUCCESS";
export const WITHOUT_DEPARTURE_REQUEST_DELETE_ERROR =
  "WITHOUT_DEPARTURE_REQUEST_DELETE_ERROR";

export const WITHOUT_DEPARTURE_REQUEST_WORKFLOW_UPDATE_REQUEST =
  "WITHOUT_DEPARTURE_REQUEST_WORKFLOW_UPDATE_REQUEST";
export const WITHOUT_DEPARTURE_REQUEST_WORKFLOW_UPDATE_SUCCESS =
  "WITHOUT_DEPARTURE_REQUEST_WORKFLOW_UPDATE_SUCCESS";
export const WITHOUT_DEPARTURE_REQUEST_WORKFLOW_UPDATE_ERROR =
  "WITHOUT_DEPARTURE_REQUEST_WORKFLOW_UPDATE_ERROR";
